import React, { Component } from 'react';
import {render} from 'react-dom';

import {Icon} from 'antd';

import utils from './../utils';
import react from 'react';


export default class Tree extends Component{
    constructor(props) {
        super(props);
        const session = JSON.parse(sessionStorage.session);

        this.expendmaping = {};

        const menu = props.data.map((item, i) => {
            if(i === 0) {
                this.expendmaping[item.key] = {
                    expend: true, 
                    active: false
                }
                return Object.assign({}, item, {expend: true, active: false})
            }

            return item;
        });
        
        this.expendmaping['T1'] = {
            expend: true, 
            active: true
        };

        this.winhash = window.location.hash;

        // const defaultMenu = utils.getStoreTree();

        // if(defaultMenu.menu) {
        //     if(!defaultMenu.expendmaping) {
        //         this.expendmaping['T1'] = {
        //             expend: true, 
        //             active: true
        //         };
        //     } else {
        //         this.expendmaping = defaultMenu.expendmaping;
        //     }

        //     this.state = {
        //         menu: defaultMenu.menu,
        //         treeUpdateTime: props.treeUpdateTime
        //     };
        // } else {
            this.state = {
                menu: [{key: 'T1', label: "", value: "T1", expend: true, active: true,  children: menu}],
                treeUpdateTime: props.treeUpdateTime
            };
        // }

        
    }

    componentWillReceiveProps(nextProps) {
        // const expands = nextProps.expands;
        if(nextProps.treeUpdateTime && nextProps.treeUpdateTime !== this.state.treeUpdateTime) {
            // if(expands && expands !== this.state.expands){
            //     this.expend(expands[0])
            // }
            const menu = nextProps.data.map((item, i) => {
                if(i === 0) {
                    this.expendmaping[item.key] = {
                        expend: true, 
                        active: false
                    }
                    return Object.assign({}, item, {expend: true, active: false})
                }
                return item;
            });

            this.expendmaping['T1'] = {
                expend: true, 
                active: true
            }    
    
            this.setState({
                menu: [{key: 'T1', label: "", value: "T1", children: menu, expend: true, active: true}],
                treeUpdateTime: nextProps.treeUpdateTime,
                // expands: nextProps.expands
            });
        }
        
    }

    expend(id) {
        const index = this.findRootMenuById(id);
        if(index !== -1) {
            const menu = this.state.menu.map((item, i) => {

                if(index === i) {
                    this.expendmaping[item.key] = {
                        active: true,
                        expend: true,
                    };

                    return Object.assign({}, item, {
                        active: true,
                        expend: true,
                        children: this.setMenuChildren(item.children || [], id)
                    })
                } else {
                    this.expendmaping[item.key] = {
                        active: false,
                        expend: false,
                    }
                    return Object.assign({}, item, {
                        active: false,
                        expend: false,
                    })
                }
                
            });
                    
            // utils.setStoreTree({
            //     menu,
            //     expendmaping: this.expendmaping
            // }, this.winhash);

            this.setState({
                menu,
            });


        } else {
            const menu = this.state.menu.map(item => {
                return Object.assign({}, item, {
                    children: this.setMenuChildren(item.children || [], id)
                });
            });

            // utils.setStoreTree({
            //     menu,
            //     expendmaping: this.expendmaping
            // }, this.winhash);


            this.setState({
                menu
            });
        }
    }

    setMenuChildren(menu, id) {
        return menu.map(item => {
            
            if(item.key === id) {
                this.expendmaping[item.key] = {
                    active: true,
                    expend: !item.expend,
                }
                return Object.assign({}, item, {
                    active: true,
                    expend: !item.expend,
                    children: this.setMenuChildren(item.children || [], id)
                });
            } else {
                this.expendmaping[item.key] = {
                    active: false,
                    expend: (this.expendmaping[item.key] || {}).expend,
                }
                return Object.assign({}, item, {
                    active: false,
                    children: this.setMenuChildren(item.children || [], id)
                });
            }
        });
    }

    findRootMenuById (id) {
        const menu = this.state.menu;
        var index = -1;
        for(var i = 0; i < menu.length; i++) {
            const item = menu[i];
            if(item.key === id) {
                index = i;
                break;
            }
        }
        return index;
    }

    getChildrenById(id){
        return Promise.resolve().then(() => {
            return [{
                id: '1344',
                label: "children1"
            }];
        });
    }

    draw(element, id){
        this.getChildrenById(id).then(data => {
            render(
                <div>
                    {
                        data.map(item => {
                            return <li>
                                {item.label}
                            </li>
                        })
                    }
                </div>,
                element
            )
        });

        
        render(
            <div>
                {
                    children.map(item => {
                        return <li>
                            {item.label}
                        </li>
                    })
                }
            </div>,
            element
        )
    }

    children(data) {
        return (
            <ul className={(this.expendmaping[data.key] || {}).expend ? "root-menu-children-expend" : "root-menu-children-default"}>
                {
                    (data.children || []).map((item, index) => (
                        <li>
                            
                            {(item.children && item.children.length > 0)  ? <a href="javascript:;" className={(this.expendmaping[item.key] || {}).active ? "root-menu-active" : "root-menu-link"} onClick={(event) => {
                                if(this.props.onSelect) {
                                    this.props.onSelect(item.key, item.label, item.disabled);
                                }
                                // console.log("event.target",event.target)
                                this.expend(item.key);
                                    // this.draw(event.target, item.id);
                                }}>
                                <span className={index === ((data.children|| []).length - 1) ? "menu-line-last" : "menu-line"}>
                                <Icon type={(this.expendmaping[item.key] || {}).expend ? "minus-square-o" : "plus-square-o"} />
                                </span>{
                                (item.children && item.children.length > 0) ? ((this.expendmaping[item.key] || {}).expend ? <i className="fa fa-folder-open menu-item-type" aria-hidden="true"></i> : <i className="fa fa-folder menu-item-type" aria-hidden="true"></i>) : <i className="fa fa-table menu-item-type menu-item-table" aria-hidden="true"></i>
                            }<font color={item.status != null && item.status == 2?"green":''}>{item.label}</font> {item.num > 0 ?<span style={{ color: '#2db7f5'}}>{"("+item.num+")"}</span>:''}<span className="root-menu-active-high"></span></a> : 
                            <a className={(this.expendmaping[item.key] || {}).active ? "root-menu-active" : "root-menu-link"} href={'javascript:;'} onClick={() => {
                                //this.props.insertOrUpdateTab(item);
                                if(this.props.onSelect) {
                                    this.props.onSelect(item.key, item.label, item.disabled);
                                }
                                this.expend(item.key);
                            }}><span className={index === ((data.children|| []).length - 1) ? "menu-line-last" : "menu-line"}></span>{
                                (item.children && item.children.length > 0) ? ((this.expendmaping[item.key] || {}).expend ? <i className="fa fa-folder-open menu-item-type" aria-hidden="true"></i> : <i className="fa fa-folder menu-item-type" aria-hidden="true"></i>) : <i className="fa fa-table menu-item-type menu-item-table" aria-hidden="true"></i>
                            }<font color={item.status != null && item.status == 2?"green":''}>{item.label}</font> {item.num > 0 ?<span style={{ color: '#2db7f5'}}>{"("+item.num+")"}</span>:''}<span className="root-menu-active-high"></span>
                            </a> 
                            }

                            {
                                item.children ? this.children(item) : ''
                            }
                        </li>
                    ))
                }
            </ul>
        )
    }

    getExpendTop(expend) {
        if(expend) {
            const top = (this.state.menu.length - 1 ) * 35 + 40;
            return {
                marginTop: -top,
                paddingTop: top
            };
        } else {
            return {
                marginTop: 0,
                paddingTop: 0
            }
        }
    }

    

    render() {
        return (
            <div className="root-menu">
                <div className="root-menu-container">
                    <h1></h1>
                    {
                        this.state.menu.map((menu, i) => (
                            <div className={(this.expendmaping[menu.key] || {}).expend === true ? "root-menu-section root-menu-expend" : "root-menu-section"}>
                                <h3 className={(this.expendmaping[menu.key] || {}).active ? "root-menu-active" : "root-menu-defaults"} onClick={() => {
                                    this.expend(menu.key);
                                }}>
                                <i className="fa fa-folder" />{menu.label}
                                <Icon type={(this.expendmaping[menu.key] || {}).expend ? "down" : "up"} /></h3>
                                <div className="root-menu-view">
                                    <div className="root-menu-scroll">
                                    {
                                        this.children(menu)
                                    }
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        )
    }
}